import { useMutation, useQueryClient } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import { toastErrorApi, toastExito } from "@/lib/toast";
import {
  crearArea,
  editarArea,
  type CrearAreaInput,
  type EditarAreaInput,
} from "../services/areas-service";

/**
 * Crear área · invalida el cache de admin y notifica al caller via `onCreado`
 * para que cierre el form. La notificación de éxito vive en el hook (no en
 * el componente) porque es uniforme en todo el flujo.
 */
export function useCrearArea(opts?: { onCreado?: () => void }) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CrearAreaInput) => crearArea(input),
    onSuccess: (area) => {
      toastExito({ title: `Área "${area.nombre}" creada`, message: "Disponible en el catálogo." });
      void qc.invalidateQueries({ queryKey: qk.adminAreas });
      opts?.onCreado?.();
    },
    onError: toastErrorApi,
  });
}

/**
 * Editar área · misma estrategia · invalida cache + notifica + callback.
 */
export function useEditarArea(opts?: { onEditado?: () => void }) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: EditarAreaInput }) => editarArea(id, input),
    onSuccess: () => {
      toastExito({ title: "Área actualizada", message: "Cambios guardados." });
      void qc.invalidateQueries({ queryKey: qk.adminAreas });
      opts?.onEditado?.();
    },
    onError: toastErrorApi,
  });
}
